<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de Cajas para Tienda</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refresh</a>
            </div>
            <div class="col-sm-6">
              <form action="#" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                </form>         
      </div>
    </div>
  </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">Caja</th>
                <th scope="col">Tienda</th>
                <th scope="col" class="text-center">Cuenta Bancaria</th>
                <th scope="col" class="text-center">Serie Factura</th>
                <th scope="col" class="text-center">Serie Nota de Credito</th>
                <th scope="col" class="text-center">Serie Recibos</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id">
                <td>{{ current.caja }}</td>
                <td scope="row">{{ current.tienda.nombre }}</td>
                <td class="text-center" >{{ current.cuenta_bancaria.nombre }}</td>
                <td class="text-center" >{{ current.serie_fact.serie }}</td>
                <td class="text-center" >{{ current.serie_nota.serie }}</td>
                <td class="text-center" >{{ current.serie_rc.serie}}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CajaService from "@/services/cxc/CajaService";

export default {
  components: {
    PaginationComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      data: []
    };
  },
  computed: {
    ...mapGetters({
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      CajaService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
        this.current.id;
    });
  }

  this.refreshData();
  this.clearFilterData();
  },
  methods: {

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
        cuenta_bancaria: this.filterCuenta,
        serie_fact: this.filterFactura,
        serie_nota: this.filterNota,
        serie_rc: this.filterRecibo,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
        cuenta_bancaria: this.filterCuenta,
        serie_fact: this.filterFactura,
        serie_nota: this.filterNota,
        serie_rc: this.filterRecibo,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.filterCuenta = null;
      this.filterFactura = null;
      this.filterNota = null;
      this.filterRecibo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
        cuenta_bancaria: this.filterCuenta,
        serie_fact: this.filterFactura,
        serie_nota: this.filterNota,
        serie_rc: this.filterRecibo,
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      CajaService.fetch(params).then(res => {
        self.data = res.data;
      });
    },
    showModalEdit() {}
  }
};
</script>
